<template>
  <span :class="classes" :style="styles">
    <!--        图片-->
    <!--        <span v-if="src" :style="{backgroundImage:`url(${src})`}"><img :src="src" @error="handleError"></span>-->
    <span
      v-if="src"
      style="display: flex; justify-content: center; width: 100%; height: 100%"
      ><img :src="src" @error="handleError" style="max-height: 100%"
    /></span>
    <!--      vant的icon-->
    <Icon v-else-if="icon" :name="icon"></Icon>
    <!--      字符串 文字-->
    <span
      v-else
      ref="children"
      :class="[prefixCls + '-string']"
      :style="childrenStyle"
      ><slot></slot
    ></span>
  </span>
</template>
<script>
// 使用方法参考ivew的avatar
import { Icon, Image as VanImage } from "vant";

// 判断参数是否是其中之一
const oneOf = function (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
};

const prefixCls = "kabala-avatar";
const sizeList = ["small", "large", "default"];
export default {
  name: "kabala-userheader",
  components: { Icon, VanImage },
  props: {
    shape: {
      validator(value) {
        return oneOf(value, ["circle", "square"]);
      },
      default: "square",
    },
    size: {
      type: [String, Number],
      default() {
        return "default";
      },
    },
    src: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  data() {
    return {
      prefixCls: prefixCls,
      scale: 1,
      childrenWidth: 0,
      isSlotShow: false,
      slotTemp: null,
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.shape}`,
        {
          [`${prefixCls}-image`]: !!this.src,
          [`${prefixCls}-icon`]: !!this.icon,
          [`${prefixCls}-${this.size}`]: oneOf(this.size, sizeList),
        },
      ];
    },
    styles() {
      let style = {};
      if (this.size && !oneOf(this.size, sizeList)) {
        style.width = `${this.size}px`;
        style.height = `${this.size}px`;
        // 修改头像line-height
        var lineHeight = this.size - 2;
        style.lineHeight = `${lineHeight}px`;
        // style.lineHeight = `${this.size}px`;
        style.fontSize = `${this.size / 2}px`;
      }
      return style;
    },
    childrenStyle() {
      let style = {};
      if (this.isSlotShow) {
        style = {
          msTransform: `scale(${this.scale})`,
          WebkitTransform: `scale(${this.scale})`,
          transform: `scale(${this.scale})`,
          position: "absolute",
          display: "inline-block",
          left: `calc(50% - ${Math.round(this.childrenWidth / 2)}px)`,
        };
      }
      return style;
    },
  },
  watch: {
    size(val, oldVal) {
      if (val !== oldVal) this.setScale();
    },
  },
  methods: {
    setScale() {
      this.isSlotShow = !this.src && !this.icon;
      if (this.$refs.children) {
        // set children width again to make slot centered
        this.childrenWidth = this.$refs.children.offsetWidth;
        const avatarWidth = this.$el.getBoundingClientRect().width;
        // add 4px gap for each side to get better performance
        if (avatarWidth - 8 < this.childrenWidth) {
          this.scale = (avatarWidth - 8) / this.childrenWidth;
        } else {
          this.scale = 1;
        }
      }
    },
    handleError(e) {
      this.$emit("on-error", e);
    },
  },
  beforeCreate() {
    this.slotTemp = this.$slots.default;
  },
  mounted() {
    this.setScale();
  },
  updated() {
    if (this.$slots.default !== this.slotTemp) {
      this.slotTemp = this.$slots.default;
      this.setScale();
    }
  },
};
</script>

<style scoped>
.kabala-avatar {
  display: inline-block;
  text-align: center;
  background: #ccc;
  color: #fff;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}

.kabala-avatar-image {
  background: 0 0;
}

.kabala-avatar .van-icon {
  position: relative;
  top: 4px;
}

.kabala-avatar.kabala-avatar-icon {
  font-size: 18px;
}

.kabala-avatar-large {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
}

.kabala-avatar-large.kabala-avatar-icon {
  font-size: 24px;
}

.kabala-avatar-large .van-icon {
  position: relative;
  top: 4px;
}

.kabala-avatar-small {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
}

.kabala-avatar-small.kabala-avatar-icon {
  font-size: 14px;
}

.kabala-avatar-square {
  border-radius: 0.8vw;
  /*border-radius: 4px;*/
}
.kabala-avatar-circle {
  border-radius: 50%;
}

.kabala-avatar > img {
  width: 100%;
  height: 100%;
}
</style>
